export const Getting_Order_History = "Getting_Order_History";
export const Order_History_Success = "Order_History_Success";
export const Order_History_Fail = "Order_History_Fail";